"use strict";

exports.__esModule = true;
exports.textPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var textPropTypes = {
  align: (0, _propTypes.oneOf)(Object.keys(_constants.ALIGN)),
  appearance: (0, _propTypes.oneOf)(Object.keys(_constants.APPEARANCE)),
  children: _propTypes.node.isRequired,
  color: _propTypes.string,
  fontWeight: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(Object.keys(_constants.FONT_WEIGHT)), _propTypes.number]),
  inherit: _propTypes.bool,
  noMargins: _propTypes.bool,
  parentAs: _propTypes.string,
  truncate: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.number, _propTypes.string])
};
exports.textPropTypes = textPropTypes;